import type { PublicMapsConfig } from "./types";

export const defaultConfig: PublicMapsConfig = {
  geocodeBasePath: "/maps-api/geocode",
  styleUrl: "/map-next/basemap/1.3.2/style.json",
  tileUrlTemplate: "/tiles/iran/{z}/{x}/{y}",
  glyphUrlTemplate: "/map-next/glyphs/{fontstack}/{range}.pbf",
  rtlPluginUrl: "/map-next/basemap/assets/rtl/0.2.3/mapbox-gl-rtl-text.min.js",
  defaultView: {
    lat: 35.6892,
    lon: 51.389,
    zoom: 12,
    pitch: 0,
    bearing: 0,
  },
  features: {
    buildings: true,
    poi: true,
    labels: true,
    housenumbers: "experimental",
    highContrast: "experimental",
    darkStyle: "disabled",
  },
};

export function getConfig(): PublicMapsConfig {
  return {
    ...defaultConfig,
    ...(window.__MAPPINO_PUBLIC_MAPS_CONFIG__ ?? {}),
    defaultView: {
      ...defaultConfig.defaultView,
      ...(window.__MAPPINO_PUBLIC_MAPS_CONFIG__?.defaultView ?? {}),
    },
    features: {
      ...defaultConfig.features,
      ...(window.__MAPPINO_PUBLIC_MAPS_CONFIG__?.features ?? {}),
    },
  };
}
